(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-v3-ad"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const dataJson = {
      module: 'SidebarAd',
    }
    const link = document.querySelector('.blog-v3-ad a')?.href
    if(link){
      // 完整跳转链接,未配置则为：null(非字符串)
      dataJson.link = link
    }
    document.querySelectorAll('.blog-v3-ad .ad-img').forEach((item) => {
      item.addEventListener('click', function () {
         // 识别图片alt内容text，若无则固定为AdsImage
        dataJson.button_name = item.alt || 'AdsImage'
        gaPushDataLayer('blogs_collection_user_clicks', dataJson);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_blog-v3-other-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const h2Title = document.querySelector('.blog-v3-other-categories-title')?.textContent || '';
    document.querySelectorAll('.blog-v3-other-category-item').forEach((item) => {
      item.addEventListener('click', function () {
        const aDom = item.querySelector('a');
        gaPushDataLayer('blogs_collection_user_clicks', {
          module: h2Title, // 识别分类标题H2text
          button_name: aDom.textContent, // 识别按钮内容text
          link: aDom.href, // 完整跳转链接,未配置则为：null(非字符串)
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_blog-v3-tags"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.blog-v3-tags .blog-v3-tag-item').forEach((item) => {
      item.addEventListener('click', function () {
        const aDom = item.querySelector('a');
        gaPushDataLayer('blogs_collection_user_clicks', {
          module: 'SidebarCategory', // 固定为SidebarCategory
          button_name: aDom.dataset.content, // 识别按钮内容text
          link: aDom.href, // 完整跳转链接,未配置则为：null(非字符串)
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
